import { RootState } from 'store/rootReducer';

export const notifications = (state: RootState) => state.ui.notifications;
